import { AppConstants } from "./app-constants";
import { Base } from "./index";

export function registerElement(constructor: CustomElementConstructor) {
    // Register    
    let prefix = AppConstants.TAG_NAME;
    let tagName = `${prefix}-${constructor.name.toLowerCase()}`;
    if (!customElements.get(tagName)) {
        customElements.define(tagName, constructor);
    }
}

/**
 * Treewaker to get vision children extending Base
 * @param startElement Document start node
 * @param display get children components who are visible
 * @returns visisble base[]
 */
export function getBaseChildren(startElement: HTMLElement) {
    const baseComponents: Node[] = [];
    const walker = document.createTreeWalker(startElement, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node) => {
            if (node instanceof Base) {
                let ele = node as Base;
                baseComponents.push(node);
                return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_SKIP;
        }
    });

    while (walker.nextNode()) { }
    return baseComponents;
}

export class ResourceLoader {
    static resourceMap : Map<string, string> = new Map();
    
    static async loadResource(resourceMap : Map<string, string>) {
        const promises:Promise<any>[]= [];
        ResourceLoader.resourceMap = resourceMap;

        ResourceLoader.resourceMap.keys().forEach(k => {
            promises.push(ResourceLoader.loadFile(k));
        });
        await Promise.all(promises).then( result =>{
            result.forEach( r =>{
                ResourceLoader.resourceMap.set(r.key,  r.res.toString());
            })
            
        });
    }

    static getResource(key:string){
        console.log( "Get resource " + key);
        const res = ResourceLoader.resourceMap.get(key);        
        if ( !res ) return "";
        ResourceLoader.resourceMap.delete(key);
        return res;
    }

    static async loadFile(url: string)  {
        return fetch(url)            
            .then(response => {
                if ( !response.ok) {
                    throw new Error("no file");
                }
                return response.text();                              
            }).then( responseText =>{                
                return {key:url, res:responseText};  
            })
            .catch(e=>{ 
                //console.warn("No file:",url); 
                return ""
            }); 
    }
}